import React from 'react';
import { cartLabels } from '@/data/content';
import Button from '@/components/ui/Button';
import { SpinnerIcon } from '@/components/ui/Icons';

interface AddToBasketCompactProps {
    disabled?: boolean;
    validating?: boolean;
    onClick: (e: React.MouseEvent) => void;
}

const AddToBasketCompact: React.FC<AddToBasketCompactProps> = ({ disabled, validating, onClick }) => (
    <Button
        type="button"
        disabled={disabled || validating}
        onClick={onClick}
        variant="primary"
        className="!p-0 w-7 h-7 rounded-lg shadow-sm"
        aria-label={validating ? cartLabels.adding_label : cartLabels.add_button}
    >
        {validating ? (
            <SpinnerIcon className="w-3.5 h-3.5" />
        ) : (
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                />
            </svg>
        )}
    </Button>
);

export default AddToBasketCompact;
